import { render, staticRenderFns } from "./OrderSelectCustomer.vue?vue&type=template&id=202bb389&scoped=true&"
import script from "./OrderSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelectCustomer.vue?vue&type=style&index=0&id=202bb389&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202bb389",
  null
  
)

export default component.exports